<template>
  <div class="d-flex align-items-center justify-content-center exchange-data w-100">
    <div v-if="!readOnly" class="card-wrapper">
      <h5 class="mb-2">
        {{ notAssignedText || $t("ar_client_not_assigned") }} ({{ dataNotAssignedCount }})
      </h5>
      <div class="my-card">
        <div class="search">
          <ez-icon size="20" icon="ezAr-icon-search" />
          <input
            @input="handleSearch()"
            v-model="dataNotAssignedSearchVal"
            type="text"
            class="w-100"
            :placeholder="$t('ar_common_search')"
          />
        </div>
        <div class="items">
          <div v-for="(item, itemIndex) in dataNotAssigned">
            <div
              class="item-wrapper"
              :class="{ selected: isSelectedParent(item), 'cursor-pointer': !readOnly }"
              @click="handleSelectData(false, itemIndex)"
            >
              <div class="item" :class="{ 'font-weight-bolder': childrensExpr }">
                {{ item[displayExpr] }}
              </div>
            </div>

            <div
              v-if="childrensExpr"
              @click="handleSelectData(false, index, item.Id)"
              v-for="(childItem, index) in item[childrensExpr]"
              :key="index"
              class="item-wrapper"
              :class="{ selected: childItem.Selected, 'cursor-pointer': !readOnly }"
            >
              <div class="item ml-2">
                {{ childItem[displayExpr] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!readOnly" class="d-flex flex-column m-1" style="width: 10%">
      <button @click="() => handleChangeData('right')">></button>
      <button class="mt-1" @click="() => handleChangeData('left')"><</button>
      <button class="mt-1" @click="() => handleChangeData('all-right')">>></button>
      <button class="mt-1" @click="() => handleChangeData('all-left')"><<</button>
    </div>
    <div class="card-wrapper" :class="{ readonly: readOnly }">
      <h5 v-if="!readOnly" class="mb-2">
        {{ assignedText || $t("ar_client_assigned") }} ({{ dataAssignedCount }})
      </h5>
      <div class="my-card">
        <div class="search">
          <ez-icon size="20" icon="ezAr-icon-search" />
          <input
            class="w-100"
            @input="handleSearch(true)"
            v-model="dataAssignedSearchVal"
            type="text"
            :placeholder="$t('ar_common_search')"
          />
        </div>
        <div class="items">
          <div v-for="(item, itemIndex) in dataAssigned">
            <div
              class="item-wrapper"
              :class="{ selected: isSelectedParent(item, true), 'cursor-pointer': !readOnly }"
              @click="handleSelectData(true, itemIndex)"
            >
              <div class="item" :class="{ 'font-weight-bolder': childrensExpr }">
                {{ item[displayExpr] }}
              </div>
            </div>

            <div
              v-if="childrensExpr"
              @click="handleSelectData(true, index, item.Id)"
              v-for="(childItem, index) in item[childrensExpr]"
              :key="index"
              class="item-wrapper"
              :class="{ selected: childItem.Selected, 'cursor-pointer': !readOnly }"
            >
              <div class="item ml-2">
                {{ childItem[displayExpr] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import Fuse from "fuse.js";

const mock = [
  { Id: "Phiếu thu - Tạo phiếu thu", Active: true },
  { Id: "Phiếu chi - Xóa phiếu chi", Active: true },
  { Id: "Phiếu thu - thêm thanh toán", Active: false },
];

export default defineComponent({
  name: "SwapData",
  props: {
    readOnly: Boolean,
    searchExpr: {
      type: Array,
      default() {
        return ["NameVi", "Permission.NameVi"];
      },
    },
    childrensExpr: String,
    isFlattenData: Boolean,
    assignedText: String,
    notAssignedText: String,
    displayExpr: String,
    data: {
      type: Array,
      default() {
        return mock;
      },
    },
  },
  setup(props) {
    const rootData = ref([]);
    const rootFlattenData = ref([]);
    const dataAssigned = ref([]);

    const dataAssignedSearchVal = ref("");

    const fuseDataAssigned = computed(() => {
      let temp = rootData.value.filter((v) => v.Active);
      if (props.childrensExpr) {
        temp = rootData.value
          .filter(
            (item) => item[props.childrensExpr].findIndex((childItem) => childItem.Active) > -1
          )
          .map((item) => ({
            ...item,
            [`${props.childrensExpr}`]: item[props.childrensExpr].filter(
              (childItem) => childItem.Active
            ),
          }));
      }
      return new Fuse(temp, { keys: props.searchExpr, threshold: 0.3 });
    });
    const dataNotAssigned = ref([]);
    const fuseDataNotAssigned = computed(() => {
      let temp = rootData.value.filter((v) => !v.Active);
      if (props.childrensExpr) {
        temp = rootData.value
          .filter(
            (item) => item[props.childrensExpr].findIndex((childItem) => !childItem.Active) > -1
          )
          .map((item) => ({
            ...item,
            [`${props.childrensExpr}`]: item[props.childrensExpr].filter(
              (childItem) => !childItem.Active
            ),
          }));
      }
      return new Fuse(temp, { keys: props.searchExpr, threshold: 0.3 });
    });
    const dataAssignedCount = computed(() => {
      let count = 0;
      if (props.childrensExpr) {
        const temp = [];
        dataAssigned.value.forEach((data) => {
          data[props.childrensExpr].forEach((childItem) => {
            temp.push(childItem);
          });
        });
        count = temp.length;
      } else {
        count = dataAssigned.value.length;
      }
      return count;
    });
    const dataNotAssignedCount = computed(() => {
      let count = 0;
      if (props.childrensExpr) {
        const temp = [];
        dataNotAssigned.value.forEach((data) => {
          data[props.childrensExpr].forEach((childItem) => {
            temp.push(childItem);
          });
        });
        count = temp.length;
      } else {
        count = dataNotAssigned.value.length;
      }
      return count;
    });
    const isSelectedParent = (item, isAssigned) => {
      if (props.childrensExpr) {
        const temp = isAssigned ? [...dataAssigned.value] : [...dataNotAssigned.value];
        console.log(temp, "1688");
        const foundParent = temp.find((data) => data.Id === item.Id);

        const childSelectedIndex = foundParent[props.childrensExpr].findIndex(
          (childItem) => !childItem.Selected
        );
        return childSelectedIndex <= -1;
      } else {
        return item.Selected;
      }
    };
    const dataNotAssignedSearchVal = ref("");

    const handleSelectData = (active, index, parentId) => {
      if (props.readOnly) return;
      const temp = active ? [...dataAssigned.value] : [...dataNotAssigned.value];
      if (!parentId && props.childrensExpr) {
        /* temp[index].Selected = !temp[index].Selected; */
        temp[index][props.childrensExpr] = temp[index][props.childrensExpr].map((item) => ({
          ...item,
          Selected: !item.Selected,
        }));
      } else if (parentId) {
        const parentItemIndex = temp.findIndex((item) => item.Id === parentId);

        temp[parentItemIndex][props.childrensExpr][index].Selected =
          !temp[parentItemIndex][props.childrensExpr][index].Selected;
      } else {
        temp[index].Selected = !temp[index].Selected;
      }

      if (active) {
        dataAssigned.value = temp;
      } else {
        dataNotAssigned.value = temp;
      }

      /*   if (active) {
          const temp = [...dataAssigned.value]
          temp[index].Selected = ! temp[index].Selected;
          dataAssigned.value = temp;
        } else {
          const temp = [...dataNotAssigned.value]
          temp[index].Selected = ! temp[index].Selected;
          dataNotAssigned.value = temp;
        } */
    };
    const handleChangeData = (action) => {
      dataAssignedSearchVal.value = "";
      dataNotAssignedSearchVal.value = "";
      if (action === "left") {
        if (!props.childrensExpr) {
          rootData.value = rootData.value.map((v) => {
            if (dataAssigned.value.findIndex((v2) => v.Id === v2.Id && v2.Selected) > -1) {
              return { ...v, Active: false, Selected: false };
            }
            return v;
          });
        } else {
          const temp = [...rootData.value];
          temp.forEach((item) => {
            item[props.childrensExpr] = item[props.childrensExpr].map((childItem) => {
              if (dataAssigned.value.find((v) => v.Id === item.Id)) {
                if (
                  dataAssigned.value
                    .find((v) => v.Id === item.Id)
                    [props.childrensExpr]?.find((v) => v.Id === childItem.Id)?.Selected &&
                  childItem.Active
                )
                  return { ...childItem, Active: false, Selected: false };
              }
              return childItem;
            });
          });
          rootData.value = temp;
        }
        /* dataAssigned.value.filter(v=>v.Selected).forEach(v=>dataNotAssigned.value.push({...v,Active:false,Selected:false}))
            dataAssigned.value = dataAssigned.value.filter(v=>!v.Selected) */
      }
      if (action === "right") {
        if (!props.childrensExpr) {
          rootData.value = rootData.value.map((v) => {
            if (dataNotAssigned.value.findIndex((v2) => v.Id === v2.Id && v2.Selected) > -1) {
              return { ...v, Active: true, Selected: false };
            }
            return v;
          });
        } else {
          const temp = [...rootData.value];
          temp.forEach((item) => {
            console.log(item[props.childrensExpr], "2411");
            item[props.childrensExpr] = item[props.childrensExpr].map((childItem) => {
              if (dataNotAssigned.value.find((v) => v.Id === item.Id)) {
                if (
                  dataNotAssigned.value
                    .find((v) => v.Id === item.Id)
                    [props.childrensExpr]?.find((v) => v.Id === childItem.Id)?.Selected &&
                  !childItem.Active
                ) {
                  return { ...childItem, Active: true, Selected: false };
                }
              }
              return childItem;
            });
          });
          rootData.value = temp;
        }
      }
      if (action === "all-left") {
        if (!props.childrensExpr) {
          rootData.value = rootData.value.map((v) => ({ ...v, Active: false }));
        } else {
          const temp = [...rootData.value];
          temp.forEach((item) => {
            item[props.childrensExpr] = item[props.childrensExpr].map((childItem) => ({
              ...childItem,
              Active: false,
            }));
          });
          rootData.value = temp;
        }
      }
      if (action === "all-right") {
        if (!props.childrensExpr) {
          rootData.value = rootData.value.map((v) => ({ ...v, Active: true }));
        } else {
          const temp = [...rootData.value];
          temp.forEach((item) => {
            item[props.childrensExpr] = item[props.childrensExpr].map((childItem) => ({
              ...childItem,
              Active: true,
            }));
          });
          rootData.value = temp;
        }
      }

      if (action === "exchange") {
      }
    };
    const handleSearch = (assigned) => {
      if (assigned) {
        if (dataAssignedSearchVal.value) {
          dataAssigned.value = fuseDataAssigned.value
            .search(dataAssignedSearchVal.value)
            .map((c) => c.item);
        } else {
          if (props.childrensExpr) {
            dataAssigned.value = rootData.value
              .filter(
                (item) => item[props.childrensExpr].findIndex((childItem) => childItem.Active) > -1
              )
              .map((item) => ({
                ...item,
                [`${props.childrensExpr}`]: item[props.childrensExpr].filter(
                  (childItem) => childItem.Active
                ),
              }));
          } else {
            dataAssigned.value = rootData.value.filter((v) => v.Active);
          }
        }
      } else {
        if (dataNotAssignedSearchVal.value) {
          dataNotAssigned.value = fuseDataNotAssigned.value
            .search(dataNotAssignedSearchVal.value)
            .map((c) => c.item);
        } else {
          if (props.childrensExpr) {
            dataNotAssigned.value = rootData.value
              .filter(
                (item) => item[props.childrensExpr].findIndex((childItem) => !childItem.Active) > -1
              )
              .map((item) => ({
                ...item,
                [`${props.childrensExpr}`]: item[props.childrensExpr].filter(
                  (childItem) => !childItem.Active
                ),
              }));
          } else {
            dataNotAssigned.value = rootData.value.filter((v) => !v.Active);
          }
        }
      }
    };

    watch(
      () => rootData,
      (items) => {
        if (items.value.length > 0) {
          if (!props.childrensExpr) {
            dataAssigned.value = items.value.filter((item) => item.Active);
            dataNotAssigned.value = items.value.filter((item) => !item.Active);
          } else {
            const tempAssigned = items.value
              .filter((item) => item[props.childrensExpr].find((childItem) => childItem.Active))
              .map((item) => ({
                ...item,
                [`${props.childrensExpr}`]: item[props.childrensExpr].filter(
                  (childItem) => childItem.Active
                ),
              }));
            const tempNotAssigned = items.value
              .filter((item) => item[props.childrensExpr].find((childItem) => !childItem.Active))
              .map((item) => ({
                ...item,
                [`${props.childrensExpr}`]: item[props.childrensExpr].filter(
                  (childItem) => !childItem.Active
                ),
              }));
            dataAssigned.value = tempAssigned;
            dataNotAssigned.value = tempNotAssigned;
          }
        }
      },
      { deep: true }
    );

    watch(
      () => props.data,
      (items) => {
        if (items) {
          rootData.value = items;
        }
      },
      { deep: true }
    );

    onMounted(() => {
      if (props.data) {
        rootData.value = props.data;
      }
    });

    return {
      isSelectedParent,
      dataNotAssignedCount,
      dataAssignedCount,
      rootData,
      handleSearch,
      dataAssigned,
      dataNotAssigned,
      handleChangeData,
      handleSelectData,
      dataAssignedSearchVal,
      dataNotAssignedSearchVal,
    };
  },
});
</script>
<style lang="scss">
.exchange-data {
  button {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 1px 5px 0 rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 6px 10px;
    background-color: #f5f5f5;
    border: none;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.87);
    :hover {
      background-color: #f5f5f5b4;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }
    :focus {
      background-color: #f5f5f5;
    }
  }
  .card-wrapper.readonly {
    width: 100%;
  }
  .card-wrapper {
    width: 43%;
    .my-card {
      width: 100%;
      padding: 12px 0;

      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
        0 1px 5px 0 rgba(0, 0, 0, 0.12);
      .search {
        display: flex;
        align-items: center;
        padding: 8px 10px;
        margin: 15px;
        border: 1px solid #ccc;
        border-radius: 8px;
        min-height: 32px;
        input {
          outline: none;
          border: none;
        }
      }

      .items {
        height: 300px;
        overflow-y: auto;
        .item-wrapper {
          transition: 0.3s ease;
          .item {
            padding: 10px 20px;
          }
        }
        .item-wrapper.selected {
          background-color: #cccccc6b;
        }
      }
    }
  }
}
</style>
